import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';
import { APP_CONFIG } from '@synthroneApp/app.config';
import { ApiService } from '@angular/synthrone-design/services';
import { MatDialog } from '@angular/material';
import { PipelineModel } from '@synthroneApp/models/pipeline/pipeline.model';
import { PipelineStageModel } from '@synthroneApp/models/pipeline-stages/pipeline-stages.model';
import { ErrorComponent } from '@angular/synthrone-design/components';
import { SortablejsModule } from 'angular-sortablejs';
import { FormControl } from '@angular/forms';
import set = Reflect.set;
import { FeatureServiceSDK } from 'ms-client-angular-sdk';

@Component({
    selector: 'pipeline-add-view',
    templateUrl: './pipeline-add-view.component.html',
    styleUrls: ['./pipeline-add-view.component.scss']
})

export class PipelineAddViewComponent implements OnInit {
    public pipeline: PipelineModel;
    public stagePipeline: PipelineStageModel;
    isDataLoading = 0;
    requiredParams = 0;
    doneTypingInterval = 1000;
    actionName: string;
    activeBlock: string;
    paramValue: string;
    files: any = [];
    tiles: any = [];
    blocksContainer: any = [];
    additionalSaveAttributes: any = ['id', 'name', 'description'];
    additionalSaveAttributesEdit: any = ['stageId', 'name', 'description'];
    paramKeys: any = [];
    blocks: any = [];
    params: any = {};
    stages: any = {};
    buildBlock: any = {};
    stage: any;
    pipelineId: any = '';
    changedModelEdit = false;
    showDetailsColumn = false;
    detailsColumn = false;
    isValid = false;
    isBlockValid = false;
    isCheckingUnique = false;
    blockIsBeingEdited: any = false;
    nameUnique = true
    typingTimer: any;
    editPipeline: any = false;
    editType = '';
    features: any = {};
    featuresFiltered: any[];

    public featureFilterCtrl: FormControl = new FormControl();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        protected api: ApiService,
        @Inject(APP_CONFIG) private config,
        protected dialog: MatDialog,
        private featureService: FeatureServiceSDK
    ) {
        this.actionName = (this.router.url.includes('add') ? 'Add' : 'Edit');
    }

    ngOnInit() {
        this.pipeline = {
            name: '',
            description: '',
            stagePipeline: [],
            requiredFeatures: []
        };

        this.blocks = [
            'source', 'build', 'deploy'
        ];

        this.blocksContainer = [];
        this.isDataLoading++
        this.featureService.featuresGet().subscribe(
            (result) => {
                const responseData = JSON.stringify(result);
                this.features = JSON.parse(responseData);

                this.featuresFiltered = [this.features];
                this.featureFilterCtrl.valueChanges.subscribe((featureFilter) => {
                    this.featuresFiltered = this.features.filter(f => f.name.toLowerCase().trim().indexOf(featureFilter.toLowerCase().trim()) > -1)
                });
                this.api.makeRequest('api_system_stage_list', {}, 'publisher').subscribe(
                    (result) => {
                        this.stages = result['data'];
                        if (this.actionName !== 'Edit') {
                            this.isDataLoading--;
                        } else {
                            this.pipelineId = (this.router.url).match(/\d+/)[0];
                            this.api.makeRequest('api_system_pipeline_details', {
                                id: this.pipelineId
                            }, 'publisher').subscribe(
                                (result) => {
                                    this.isDataLoading--;
                                    const featuresIds = [];

                                    Object.keys(result['requiredFeatures']).forEach((key, index) => {
                                        featuresIds.push(this.features[result['requiredFeatures'][key]]['name'])
                                    });

                                    this.pipeline = {
                                        name: result['name'] ? result['name'] : '',
                                        description: result['description'] ? result['description'] : '',
                                        stagePipeline: [],
                                        requiredFeatures: featuresIds
                                    };

                                    const finalOrder = this.setupCorrentPipelinesOrder(result);

                                    Object.keys(result['stage_pipeline']).forEach((key, index) => {
                                        this.blocksContainer.push({
                                            type: finalOrder[key]['stageType'],
                                            params: finalOrder[key]['params']
                                        })
                                        for (let i = 0; i < this.additionalSaveAttributesEdit.length; ++i) {
                                            if (this.additionalSaveAttributesEdit[i] == 'stageId') {
                                                this.blocksContainer[this.blocksContainer.length - 1]['params']['id'] = finalOrder[key][this.additionalSaveAttributesEdit[i]];
                                            } else {
                                                this.blocksContainer[this.blocksContainer.length - 1]['params'][this.additionalSaveAttributesEdit[i]] = finalOrder[key][this.additionalSaveAttributesEdit[i]];
                                            }
                                        }
                                    })

                                    this.isFormValid();
                                },
                                (error) => {
                                    this.isDataLoading--;
                                    const dialogRef = this.dialog.open(ErrorComponent, {
                                        data: {
                                            message: error
                                        }
                                    }).afterClosed().subscribe(result => {
                                        this.router.navigate(['/pipelines']);
                                    });
                                });
                        }
                    },
                    (error) => {
                        this.isDataLoading--;
                        const dialogRef = this.dialog.open(ErrorComponent, {
                            data: {
                                message: error
                            }
                        }).afterClosed().subscribe(result => {
                            this.router.navigate(['/pipelines']);
                        });
                    }
                );
            },
            (error) => {
                this.isDataLoading--;
                const dialogRef = this.dialog.open(ErrorComponent, {
                    data: {
                        message: error
                    }
                }).afterClosed().subscribe(result => {
                    this.router.navigate(['/pipelines']);
                });
            }
        );
    }

    breadcrumbsFN = () => {
        return Observable.of([{
                breadcrumb: 'ADMINER',
                url: '/'
            },
            {
                breadcrumb: 'Manage Pipelines',
                url: '/pipelines'
            },
            {
                breadcrumb: this.actionName + ' Pipelines',
                url: this.router.url
            }
        ]);
    }

    setupCorrentPipelinesOrder = (result) => {
        const pipelineStageCorrectOrder = [];
        let isFirstId;
        Object.keys(result['stage_pipeline']).forEach((key, index) => {
            if (result['stage_pipeline'][key]['isFirst'] === true) {
                isFirstId = result['stage_pipeline'][key]['id'];
            }
            pipelineStageCorrectOrder[result['stage_pipeline'][key]['id']] = result['stage_pipeline'][key];
        });

        const finalOrder = [];

        let nextId = isFirstId;
        for (let i = result['stage_pipeline'].length - 1; i >= 0; i--) {
            finalOrder.push(pipelineStageCorrectOrder[nextId]);
            if (typeof pipelineStageCorrectOrder[nextId]['next'] != 'undefined') {
                nextId = pipelineStageCorrectOrder[nextId]['next']['id'];
            }
        }

        return finalOrder;
    }

    addBlock(block) {
        if (this.activeBlock != block || this.blockIsBeingEdited !== false) {
            this.clearBlock();
        }
        this.detailsColumn = true;
        this.activeBlock = block;
        this.editType = 'Add block';
    }

    isBlocksNotEmpty() {
        let valid = true
        Object.keys(this.blocks).forEach((key, index) => {
            if (this.blocksContainer.length == 0) {
                valid = false;
            }
        });
        return valid;
    }

    isFormValid() {
        if (this.isBlocksNotEmpty() && this.pipeline.name && this.nameUnique) {
            this.isValid = true;
        } else {
            this.isValid = false;
        }
    }

    isAddBlockValid() {
        setTimeout(() => {
            let validateContinue = true;
            let buildBlockRequiredLength = 0;
            Object.keys(this.buildBlock).forEach((key, index) => {
                if (typeof this.params[key] != 'undefined' && this.params[key]['required'] != 'undefined' && this.params[key]['required'] === true) {
                    buildBlockRequiredLength++;
                    if (this.buildBlock[key] === '') {
                        buildBlockRequiredLength--
                        validateContinue = false;
                        this.isBlockValid = false;
                    }
                }
            });

            if (validateContinue) {
                if (this.paramValue && (this.requiredParams == buildBlockRequiredLength)) {
                    this.isBlockValid = true;
                    return true;
                } else {
                    this.isBlockValid = false;
                    return false;
                }
            }
        }, 0);
    }

    clearBlock() {
        this.buildBlock = {};
        this.params = {};
        this.paramValue = '';
        this.stage = {};
        this.changedModelEdit = false;
        this.blockIsBeingEdited = false;
        this.isAddBlockValid();
    }

    hideBlock() {
        this.detailsColumn = false;
        this.clearBlock();
    }

    setParams($status) {
        this.getStage(this.paramValue);
        this.params = this.stage['property'];
        if ($status) {
            this.setRadioButtons();
        }
        this.getRequiredParams();
    }

    setRadioButtons() {
        Object.keys(this.stage['property']).forEach((key, index) => {
            if (this.stage['property'][key]['type'] == 'radio') {
                this.buildBlock[key] = this.stage['property'][key]['options'][0]['value'];
            }
        });
    }

    getRequiredParams() {
        this.requiredParams = 0;
        Object.keys(this.params).forEach((key, index) => {
            if (this.params[key]['required']) {
                this.requiredParams++;
            }
        });
    }

    getStage(id) {
        this.stages.filter((obj) => {
            if (obj['id'] == id) {
                this.stage = obj;
            }
        });
    }

    saveBlock() {
        const activeBlock = this.getActiveBlock();
        for (let i = 0; i < this.additionalSaveAttributes.length; ++i) {
            this.additionalSaveAttributes[i]
            this.buildBlock[this.additionalSaveAttributes[i]] = this.stage[this.additionalSaveAttributes[i]];
        }
        if (this.blockIsBeingEdited === false) {
            activeBlock.push({
                type: '' + this.activeBlock,
                params: this.buildBlock
            });
        } else {
            activeBlock[this.blockIsBeingEdited] = {
                type: '' + this.activeBlock,
                params: this.buildBlock
            };
        }
        this.hideBlock();
        this.isFormValid();
    }

    getActiveBlock() {
        return this.blocksContainer;
    }

    getActiveBlockByName($name) {
        return this.blocksContainer;
    }

    removeBlock(item, $index, arrayName) {
        this.getActiveBlockByName(arrayName).splice($index, 1);
        this.isFormValid()
    }

    editBlock(item, $index, arrayName) {
        this.getStage(item['id']);
        this.params = this.stage['property'];
        this.detailsColumn = true;
        this.activeBlock = arrayName;
        this.paramValue = item['id'];
        this.blockIsBeingEdited = $index;
        this.buildBlock = item;
        this.editType = 'Submit changes';
        this.isAddBlockValid();
    }

    checkNameUnique($name) {
        this.isValid = false;
        clearTimeout(this.typingTimer);
        if ($name.length > 0) {
            this.typingTimer = setTimeout(() => {
                this.doneTyping()
            }, this.doneTypingInterval);
        }
    }

    doneTyping(submit = false) {
        this.isCheckingUnique = true;
        this.api.makeRequest('api_system_pipeline_unique_check', {
            name: this.pipeline.name,
            editId: this.pipelineId
        }, 'publisher').subscribe(
            (result) => {
                this.nameUnique = result['isUnique'];
                this.isFormValid();
                this.isCheckingUnique = false;
                if (submit && this.nameUnique) {
                    if (this.actionName == 'Add') {
                        this.createPipelineFN();
                    }
                    if (this.actionName == 'Edit') {
                        this.editPlatformFN();
                    }
                }
            },
            (error) => {
                const dialogRef = this.dialog.open(ErrorComponent, {}).afterClosed().subscribe(result => {
                    this.router.navigate(['/pipelines']);
                });
            });
    }

    uploadPipelineFile = (fileItem) => {
        return this.api.makeRequest('api_system_pipeline_stage_file_edit', {
                id: this.pipelineId,
                stage: fileItem.stage,
                file: fileItem.file
            }, 'publisher', {}, false, 'json')
            .delay(Math.random() * 1000);
    };

    uploadPipelineStageParamFiles(): Observable < any[] > {
        if (this.files.length === 0) {
            return Observable.of([]);
        }

        const observables = this.files.map(fileItem => {
            return this.uploadPipelineFile(fileItem).catch(() => Observable.of(null)).map(item => item.file);
        });

        return Observable.combineLatest(observables);
    };

    createPipeline = () => {
        this.isDataLoading++;
        let isFirst = 1;
        this.blocksContainer.forEach((blockC, innerIndex) => {
            const stageId = blockC['params']['id'];
            Object.keys(blockC).forEach((containerKey, containerIndex) => {
                if (this.additionalSaveAttributes.indexOf(containerKey) > -1) {
                    delete blockC[containerKey]
                }
            });

            Object.keys(blockC['params']).forEach(param => {
                if (blockC['params'][param] instanceof File) {
                    const findFile = this.files.find(item => item.stage === stageId && item.param === param);
                    blockC['params'][param] = JSON.stringify({ path: findFile.value, name: findFile.file.name });
                }
            });

            this.stagePipeline = {
                'params': Object.keys(blockC['params']).length !== 0 ? blockC['params'] : [],
                'isFirst': isFirst,
                'stage': stageId,
            };
            this.pipeline['stagePipeline'].push(this.stagePipeline);
            isFirst = 0;
        });
    }

    createPipelineFN = () => {
        let params = Object.assign({}, this.pipeline);
        params.requiredFeatures = Object.keys(params.requiredFeatures).length !== 0 ? params.requiredFeatures : params.requiredFeatures;
        this.api.makeRequest('api_system_pipeline_create', params, 'publisher').subscribe(
            (result) => {
                this.isDataLoading--;
                this.router.navigate(['/pipelines']);
                this.isValid = true;
            },
            (error) => {
                this.isDataLoading--;
                const dialogRef = this.dialog.open(ErrorComponent, {
                    data: {
                        message: error
                    }
                });
                this.isValid = true;
                this.pipeline['stagePipeline'] = [];
            });
    }

    editPlatformFN = () => {
        let params = Object.assign({}, this.pipeline);
        params.requiredFeatures = Object.keys(params.requiredFeatures).length !== 0 ? params.requiredFeatures : params.requiredFeatures;
        params.id = this.pipelineId;
        this.api.makeRequest('api_system_pipeline_edit', params, 'publisher').subscribe(
            (result) => {
                this.isDataLoading--;
                this.router.navigate(['/pipelines']);
                this.isValid = true;
            },
            (error) => {
                this.isDataLoading--;
                const dialogRef = this.dialog.open(ErrorComponent, {
                    data: {
                        message: error
                    }
                });
                this.isValid = true;
            });
    }

    submitFN(isValid: boolean) {
        this.isValid = false;

        this.uploadPipelineStageParamFiles().subscribe(urls => {
            if (urls.includes(null)) {
                this.dialog.open(ErrorComponent, {
                    data: {
                        message: 'Files were not uploaded.'
                    }
                });
                this.isValid = true;
            } else {
                for (let i = 0; i < this.files.length; i++) {
                    this.files[i].value = urls[i];
                }
                this.createPipeline();
                this.doneTyping(true);
            }
        });
    }

    atLeastOneEachType = () => {
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
        return this.blocksContainer.map(bc => bc.type).filter(onlyUnique).length == this.blocks.length;
    }

    onFileChange(event, paramName) {
        this.files.push({
            file: event.target.files[0],
            stage: this.stage.id,
            param: paramName
        });

        this.buildBlock[paramName] = event.target.files[0];
    }

    detachFile = (paramName) => {
        const found = this.files.findIndex(item => item.param === paramName && item.stage === this.stage.id);
        if (found > -1) {
            delete this.files[found];
        }

        this.buildBlock[paramName] = null;
    };

    parseJson = (data) => {
        return JSON.parse(data);
    };

    downloadFile = (paramName) => {
        const fileParams = this.parseJson(this.buildBlock[paramName]);
        this.api.makeRequest('api_system_pipeline_stage_file_download', {
                id: this.pipelineId,
                slug: fileParams.path
            }, 'publisher', {}, false, 'blob')
            .subscribe(
                (data: any) => {
                    const blob = new Blob([data], { type: 'document' });
                    const downloader = document.createElement('a');
                    downloader.href = window.URL.createObjectURL(blob);
                    downloader.download = fileParams.name;
                    downloader.click();
                    downloader.remove();
                },
                (error) => {
                    const dialogRef = this.dialog.open(ErrorComponent, {
                        data: {
                            message: 'Cannot download file!'
                        }
                    });
                }
            );

    };
}



// WEBPACK FOOTER //
// ./src/app/components/views/pipeline-add-view/pipeline-add-view.component.ts